import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-alert-info',
  templateUrl: './alert-info.component.html'
})
export class AlertInfoComponent implements OnInit {

  @Input() mensagem: string;
  @Input() botaoFechar: boolean;

  constructor() {
    this.botaoFechar = false;
  }

  ngOnInit() {
  }

}
